/* eslint-disable default-case */
import {
  PackageItem,
} from '@/features/shipment/types';
import store from '@/features/common/store';
import { NotificationData } from '@/features/settings/types';
import { isEnabledPref } from '.';

const getIsAllPackagesAreEnvelops = (packageList: PackageItem[]): boolean => {
  if (!packageList.length) return false;

  const packageWithoutEnvelop = packageList.find((packageItem) => packageItem.packageType !== 'Envelope');
  return !packageWithoutEnvelop;
};

export const getPrintNotifications = (
  packages: PackageItem[],
): void => {
  const notificationSettings = store.getters.getNotificationPrefs;
  const notificationData: Array<NotificationData> = [];

  const isMinimumPackaging = packages.length && !getIsAllPackagesAreEnvelops(packages);

  if (isMinimumPackaging && isEnabledPref(notificationSettings, 'MinimumPackaging')) {
    notificationData.push({ name: 'MinimumPackaging' });
  }

  if (isEnabledPref(notificationSettings, 'SchedulePickup')) {
    notificationData.push({ name: 'SchedulePickup' });
  }

  if (notificationData.length) {
    store.dispatch('showNotification', notificationData);
  }
};
